import React, { useState } from "react";
import {
  makeStyles,
  Box,
  Typography,
  useMediaQuery,
  useTheme,
  Tooltip,
  ClickAwayListener,
} from "@material-ui/core";

// import MealIcon from "../../../assets/img/meal.svg";
// import NoMealIcon from "../../../assets/img/no-meal.svg";
import TooltipIcon from "../../../assets/img/tooltip.svg";

const useStyles = makeStyles({
  flightTime: {
    "& span": {
      "&:first-of-type": {
        marginRight: "4px",
      },
    },
  },
  uppercaseToCapitalize: {
    textTransform: 'lowercase',
    "& b": {
        display: 'block',
        "&:first-letter": {
            textTransform: 'uppercase'
        }
    }
  }
});

const FlightTime = ({ duration, meal, carrierInfo, operatedBy }) => {
  const { flightTime } = useStyles();
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };
  const show = useMediaQuery(theme.breakpoints.down("xs"));
  return (
    <>
      <Box display="flex" alignItems="center" className={flightTime}>
        <Typography variant="caption" color="textSecondary">
          Flight time:
        </Typography>
        <Typography variant="caption" color="textSecondary">
          <b>{duration}</b>
        </Typography>
        {/*{!show && (*/}
        {/*  <Box display="flex">*/}
        {/*    <Box display="flex" ml={2} mr={0.6}>*/}
        {/*      {meal ? <img src={MealIcon} alt="meal" /> : ' '}*/}
        {/*    </Box>*/}
        {/*    <Typography*/}
        {/*      variant="caption"*/}
        {/*      color="textSecondary"*/}
        {/*    >*/}
        {/*      <b>{meal ? 'Meal' : 'No Meal'}</b>*/}
        {/*    </Typography>*/}
        {/*  </Box>*/}
        {/*)}*/}
      </Box>

      {show && (
        <Box className={flightTime} display="flex" alignItems="center">
          <Typography variant="caption" color="textSecondary">
            Flight number:
          </Typography>
          <Typography variant="caption" color="textSecondary">
            <b>{carrierInfo.code}</b>
          </Typography>
          <Box ml={0.5}>
            <ClickAwayListener onClickAway={handleTooltipClose}>
              <Tooltip
                PopperProps={{
                  disablePortal: true,
                }}
                onClose={handleTooltipClose}
                open={open}
                disableFocusListener
                disableHoverListener
                disableTouchListener
                title={<ToolTipInfo carrierInfo={carrierInfo} meal={meal} operatedBy={operatedBy} />}
                arrow
                placement="top"
              >
                <Box onClick={handleTooltipOpen}>
                  <img src={TooltipIcon} alt="tooltip" />
                </Box>
              </Tooltip>
            </ClickAwayListener>
          </Box>
        </Box>
      )}

      {show && (
        <Box display="flex" alignItems="center" className={flightTime}>
          <Typography variant="caption" color="textSecondary">
            Flight type:
          </Typography>
          <Box display="flex">
            <Typography
              variant="caption"
              color="textSecondary"
            >
              <b>{carrierInfo.type}</b>
            </Typography>
          </Box>
        </Box>
      )}
    </>
  );
};

const ToolTipInfo = ({ carrierInfo, meal, operatedBy }) => {
    const { uppercaseToCapitalize } = useStyles();
  return (
    <>
      <Box display="flex">
        <Typography variant="caption">Flight plane:</Typography>
        <Typography variant="caption">
          <b>{carrierInfo.plane}</b>
        </Typography>
      </Box>
      <Box display="flex">
        <Typography variant="caption" style={{ flex: 'none' }}>Operated by:</Typography>
        <Typography variant="caption" className={uppercaseToCapitalize}>
            <b>{operatedBy}</b>
        </Typography>
      </Box>
      {/*<Box display="flex">*/}
      {/*  <Typography variant="caption">*/}
      {/*    {meal ? "Meal Included" : "No Meal"}*/}
      {/*  </Typography>*/}
      {/*</Box>*/}
    </>
  );
};

export default FlightTime;
